export default `
uniform sampler2D uRevealPosition;
uniform float uRevealProgress;
uniform vec3 uMouse; // mouse position

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;

    vec2 position = texture2D(uCurrentPosition, vUv).xy;
    vec2 revealPos = texture2D(uRevealPosition, vUv).xy;
    vec4 forces = texture2D(uCurrentForces, vUv);
    

    vec2 speed = forces.xy;
    position = mix(position, revealPos, uRevealProgress);

    position += speed;

    gl_FragColor = vec4(position, 0., 0.);
}`;
//# sourceMappingURL=simFragmentPosition.js.map